module.exports = __webpack_public_path__ + "media/site_templates/www.mulchingservices.net.au/images/testimonials-31d1757b9c3699b89cf4755eb1064aea.jpg";